export {AccessRestrictedPage} from "./AccessRestrictedPage";
export type {AccessRestrictedPageProps} from "./AccessRestrictedPage";
